const moment = require('moment')

const format = "YYYY-MM-DD HH:mm:ss"
const noHourformat = "YYYY-MM-DD"

// 获取近三个月的时间
export const getSinceThreeMonth = (formatType = format) => {
	let res = [
		moment(new Date(new Date().getTime() - 3600 * 1000 * 24 * 90)).format(formatType),
		moment(new Date()).format(formatType),
	];
	return res;
}

export const getTodayOneMonth = () => {
	let res = [
		moment(new Date(new Date().getTime() - 3600 * 1000 * 24 * 15)).format(format),
		moment(new Date(new Date().getTime() + 3600 * 1000 * 24 * 15)).format(format),
	];
	return res;
}

// 获取近一个月的时间
export const getRecentOneMonth = () => {
	let res = [
		moment(new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 29)).format(format),
		moment(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)).format(format)
	];
	return res;
}

export const getNoHourTodayOneMonth = () => {
	let res = [
		moment(new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)).format(noHourformat),
		moment(new Date(new Date().getTime())).format(noHourformat),
	];
	return res;
}

// 获取近7天的时间
export const getRecentSevenDay = () => {
	let res = [
		moment(new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 6)).format(format),
		moment(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)).format(format)
	];
	return res;
}

// 获取近一年的时间
export const getRecentOneYear = () => {
	let res = [
		moment(new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 364)).format(format),
		moment(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)).format(format)
	];
	return res;
}

// 获取今天的时间戳
export const getTodayTimestamps = () => {
	let res = [
		moment(new Date(new Date(new Date().toLocaleDateString()).getTime())).format(format),
		moment(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)).format(format)
	];
	return res;
}

// 获取近今天的时间
export const getTodayTime = (unix) => {
	let res = [
		moment(new Date(new Date(new Date(unix).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)).format(format),
		moment(new Date(new Date(new Date(unix).toLocaleDateString()).getTime())).format(format),
	];
	return res;
}
//获取当前时间 yyyy-MM-dd HH:mm:ss
export const getFullTime = (type) => {
	var date = new Date();
	var seperator1 = "-";
	var seperator2 = ":";
	//外国的月份都是从0开始的，所以+1
	var month = date.getMonth() + 1;
	var strDate = date.getDate();
	var strMinute = date.getMinutes()
	var strSeconds = date.getSeconds()
	if (month >= 1 && month <= 9) {
		month = "0" + month;
	}
	if (strDate >= 0 && strDate <= 9) {
		strDate = "0" + strDate;
	}
	if (strMinute >= 0 && strMinute <= 9) {
		strMinute = "0" + strMinute;
	}
	if (strSeconds >= 0 && strSeconds <= 9) {
		strSeconds = "0" + strSeconds;
	}
	//获取当前时间 yyyy-MM-dd HH:mm:ss

	var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + " " + date.getHours() + seperator2 + strMinute + seperator2 + strSeconds;
	if (type === 'date') return date.getFullYear() + seperator1 + month + seperator1 + strDate
	else {
		return currentdate;
	}

}

//计算两个日期天数差的函数，通用
export const dateDiff = (data) => {
	//传入格式 2019-12-18
	var date = data.toString();
	var year = date.substring(0, 4);
	var month = date.substring(5, 7);
	var day = date.substring(8, 10);
	var d1 = new Date(year + '/' + month + '/' + day);
	var dd = new Date();
	var y = dd.getFullYear();
	var m = dd.getMonth() + 1;
	var d = dd.getDate();
	var d2 = new Date(y + '/' + m + '/' + d);
	var iday = parseInt(d2 - d1) / 1000 / 60 / 60 / 24;
	return iday;
	//-1为明天   负多少就是差多少
}

export const returnFullTime = (value, type) => {
	//时间转换（格式：2019-04-17 15:28:48 ||2019-04-17）
	let date = new Date(value);
	let y = date.getFullYear();
	let MM = date.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM;
	let d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	let h = date.getHours();
	h = h < 10 ? ('0' + h) : h;
	let m = date.getMinutes();
	m = m < 10 ? ('0' + m) : m;
	let s = date.getSeconds();
	s = s < 10 ? ('0' + s) : s;
	let time = type ? y + '-' + MM + '-' + d : y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
	return time
}

// 距离当前时间几小时后
export const afterCurrentTime = (value) => {
	var timestamp = new Date().getTime();
	timestamp = timestamp + value * 60 * 60 * 1000;
	var dateAfter = new Date(timestamp);
	let y = dateAfter.getFullYear();
	let MM = dateAfter.getMonth() + 1;
	MM = MM < 10 ? ('0' + MM) : MM;
	let d = dateAfter.getDate();
	d = d < 10 ? ('0' + d) : d;
	let h = dateAfter.getHours();
	h = h < 10 ? ('0' + h) : h;
	let m = dateAfter.getMinutes();
	m = m < 10 ? ('0' + m) : m;
	let s = dateAfter.getSeconds();
	s = s < 10 ? ('0' + s) : s;
	let time = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
	return time
}
// 时间取整(2020-12-02 23:34:32) --> (2020-12-03 00:00:00)
export const parseIntTime = (time) => {
	//  补0
	let filterZero = (i) => {
		return i < 10 ? `0${i}` : i
	}
	let [t1, t2, t3, t4, t5, t6] = [
		new Date(time).getFullYear(),
		filterZero(new Date(time).getMonth() + 1),
		filterZero(new Date(time).getDate()),
		filterZero(new Date(time).getHours()),
		filterZero(new Date(time).getMinutes()),
		filterZero(new Date(time).getSeconds()),
	]

	filterSeconds()

	function filterSeconds() {
		//  秒取整运算
		let i = parseInt(t6)
		if (i >= 0 && i <= 30) {
			t6 = `00`
		} else {
			// 分钟进位
			t6 = `00`
			t5 = parseInt(t5) + 1
			filterMinutes(t5)
		}
	}

	function filterMinutes() {
		//  分钟取整运算
		let i = parseInt(t5)
		if (i >= 0 && i <= 30) {
			t5 = `00`
		} else {
			// 小时进位
			t5 = `00`
			t4 = parseInt(t4) + 1
			filterHours(t4)
		}
	}

	function filterHours(i) {
		i = parseInt(i)
		// 现在是24小时制，可修改为12小时制
		if (i >= 0 && i < 24) {
			t4 = filterZero(i)
		} else {
			// 天数进位
			t4 = `00`
			t3 = parseInt(t3) + 1
			filterDay(t3)
		}
	}

	function filterDay(i) {
		//  获取当月有多少天
		let nowMD = parseInt(new Date(t1, t2, 0).getDate())

		i = parseInt(i)
		if (i >= 0 && i <= nowMD) {
			t3 = filterZero(i)
		} else {
			// 月份进位
			t3 = `01`
			t2 = parseInt(t2) + 1
			filterMonth(t2)
		}
	}

	function filterMonth(i) {
		i = parseInt(i)
		if (i >= 0 && i <= 12) {
			t2 = filterZero(i)
		} else {
			// 年进位
			t2 = `01`
			t1 = parseInt(t1) + 1
		}
	}
	return `${t1}-${t2}-${t3} ${t4}:${t5}:${t6}`;
}
//返回两个时间段内的每个月份
export const getMonthBetween=(start, end)=>{
	   //传入的格式YYYY-MM
	   let result = {};
      let s = start.split("-");
      let e = end.split("-");
      let min = new Date();
      let max = new Date();
      min.setFullYear(s[0], s[1] * 1 - 1, 1); //开始日期
      max.setFullYear(e[0], e[1] * 1 - 1, 1); //结束日期
      let curr = min;
      while (curr <= max) {
        let month = curr.getMonth();
		let year = curr.getFullYear();
		let lastMonth=month+1
		 lastMonth=Number(lastMonth)<10?'0'+lastMonth:lastMonth
        if (!result[year]) {
          result[year] = [`${year}-${lastMonth}`];
        } else {
          result[year].push(`${year}-${lastMonth}`);
        }
        curr.setMonth(month + 1);
	  }
      return result;
}
//还剩多少  itemEnd:开始时间，second_appeal_time：倒计时分钟
export const Djs_timeListDay=(itemEnd, second_appeal_time)=>{
	  // 天倒计时
	  let showTime;
    //   let endItem =
    //     new Date(itemEnd).getTime() +
	// 	1000 * 60 * 60 * 24 * Number(second_appeal_time); //获取列表传的截止时间
		let endItem =
        new Date(itemEnd).getTime() +
        1000 * 60 *Number(second_appeal_time); //获取列表传的截止时间
		let nowItem = new Date().getTime(); //获取当前时间
		let rightTime = endItem -nowItem; //截止时间减去当前时间
      if (rightTime > 0) {
        //判断剩余倒计时时间如果大于0就执行倒计时否则就结束
        var dd = Math.floor(rightTime / 1000 / 60 / 60 / 24);
        var hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
        var mm = Math.floor((rightTime / 1000 / 60) % 60);
		var ss = Math.floor((rightTime / 1000) % 60);
		// if(dd>0)showTime = dd+'天'+hh + "小时" + mm + "分"
		// else showTime =hh + "小时" + mm + "分"
		showTime=[dd,hh,mm,ss]
      } else {
         showTime = [];
      }
	  return showTime;
}
//倒计时
export const Djs_timeList=()=>{

}
//获取当前月份的的最后一天 传入格式2019-02-01
export const getDay=(end_time)=>{
	let date = end_time.split("-");
	let day = new Date(date[0], date[1], 0).getDate();
	return day
}
//获得本季度的结束月份 传入格式2019-06
export const getQuarterEndDate=(val)=>{
	var quarterStartMonth = 0;
	let time=val.split('-')
	let nowYear=time[0]
	let nowMonth=time[1]
	if(nowMonth<3){
		quarterStartMonth = 0;
	}
	if(2<nowMonth && nowMonth<6){
		quarterStartMonth = 3;
	}
	if(5<nowMonth && nowMonth<9){
		quarterStartMonth = 6;
	}
	if(nowMonth>8){
		quarterStartMonth = 9;
	}
	var quarterEndMonth = quarterStartMonth + 2;
	var monthStartDate = new Date(nowYear, quarterEndMonth, 1);
	var monthEndDate = new Date(nowYear, quarterEndMonth + 1, 1);
	var days = (monthEndDate - monthStartDate)/(1000 * 60 * 60 * 24);
	quarterEndMonth=Number(quarterEndMonth)<10?'0'+quarterEndMonth:quarterEndMonth
	var quarterStartDate = new Date(nowYear, quarterEndMonth, days);
	return 	moment(quarterStartDate).format(noHourformat)
}
